import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-change-passdword-previous',
  templateUrl: './change-passdword-previous.component.html',
  styleUrls: ['./change-passdword-previous.component.css']
})
export class ChangePassdwordPreviousComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
